import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { Trophy, Camera, Clapperboard, Menu, BookOpen, Building2, Briefcase, Gavel, ShieldCheck, LogOut, LogIn, UserPlus } from "lucide-react";

const tabCls = (active) => `flex-1 flex flex-col items-center justify-center gap-0.5 h-14 text-[11px] font-medium transition-colors ${active ? "text-[#ff4d64]" : "text-slate-400 hover:text-white"}`;

export default function BottomNav() {
  const { user, signOut, isRegional } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();
  const moreRoutes = ["/how-it-works", "/dashboard", "/portfolio", "/judge", "/admin", "/login", "/register"];
  const moreActive = open || moreRoutes.includes(loc.pathname);

  const item = (to, label, Icon, testid) => (
    <Link to={to} onClick={() => setOpen(false)} className="flex items-center gap-3 min-h-12 px-2 rounded-md text-[15px] font-medium text-[#1a1f36] hover:bg-slate-50 transition-colors" data-testid={testid}>
      <Icon className="w-5 h-5 text-slate-400" />{label}
    </Link>
  );

  return (
    <>
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 sw-navy border-t border-white/10 pb-[env(safe-area-inset-bottom)]" data-testid="bottom-nav">
        <div className="flex">
          <Link to="/" className={tabCls(loc.pathname === "/")} data-testid="bottomnav-leaderboard"><Trophy className="w-5 h-5" />Leaderboard</Link>
          <Link to="/feed" className={tabCls(loc.pathname === "/feed")} data-testid="bottomnav-feed"><Camera className="w-5 h-5" />The Feed</Link>
          <Link to="/reels" className={tabCls(loc.pathname === "/reels")} data-testid="bottomnav-reels"><Clapperboard className="w-5 h-5" />Reels</Link>
          <button onClick={() => setOpen(true)} className={tabCls(moreActive)} data-testid="bottomnav-more"><Menu className="w-5 h-5" />More</button>
        </div>
      </nav>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="rounded-t-2xl pb-[max(1rem,env(safe-area-inset-bottom))]" data-testid="more-sheet">
          <SheetHeader className="text-left pb-2"><SheetTitle className="font-display text-[#1a1f36]">More</SheetTitle></SheetHeader>
          <div className="space-y-0.5">
            {item("/how-it-works", "How it works", BookOpen, "morenav-how-it-works")}
            {user?.role === "property_user" && item("/dashboard", "My Property", Building2, "morenav-dashboard")}
            {(isRegional || user?.role === "admin") && item("/portfolio", "My Portfolio", Briefcase, "morenav-portfolio")}
            {(user?.role === "judge" || user?.role === "admin") && item("/judge", "Judging", Gavel, "morenav-judge")}
            {user?.role === "admin" && item("/admin", "Admin", ShieldCheck, "morenav-admin")}
            <div className="border-t border-slate-100 my-2" />
            {user ? (
              <button onClick={async () => { setOpen(false); await signOut(); nav("/"); }} className="w-full flex items-center gap-3 min-h-12 px-2 rounded-md text-[15px] font-medium text-[#c8102e] hover:bg-red-50 text-left transition-colors" data-testid="morenav-sign-out">
                <LogOut className="w-5 h-5" />Sign out
              </button>
            ) : (
              <>
                {item("/login", "Sign in", LogIn, "morenav-login")}
                {item("/register", "Register your property", UserPlus, "morenav-register")}
              </>
            )}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
